import { Component, EventEmitter, Input, Output } from '@angular/core';
import { translationKeys } from '../../../sharedTranslationKeys';

export interface ErrorDetail {
  title: string;
  description: string;
  source?: {
    element: HTMLElement,
    /**
     * @description used for link 'Go to {{name}}'
     * @default "Input"
     */
    name?: string
  }
}
@Component({
  selector: 'avano-errors-details',
  template: `
    <div class="title">
      {{ translationKeys.avano.errorsDetails.msg.header | translate : {count: errorDetails.length } }}</div>
    <div *ngFor="let x of errorDetails" class="error-wrapper">
      <div class="error-icon">
        <i class="icon-content-error"></i>
      </div>
      <div class="error-content">
        <div class="path">{{ x.title }}</div>
        <div class="reason">{{ x.description }}</div>
        <a class="sourcelink" *ngIf="x.source?.element" (click)="sourceLinkClicked(x.source)" tabindex="0">
          {{translationKeys.avano.errorsDetails.btn.goTo | translate}} {{x.source.name ?? 'Input'}}
        </a>
      </div>
    </div>
  `,
  styleUrls: ['./errors-details.component.scss']
})
export class AvanoErrorsDetailsComponent {
  @Input() errorDetails: ErrorDetail[] = [];
  @Output() errorSourceLinkClicked: EventEmitter<void> = new EventEmitter();

  translationKeys: typeof translationKeys = translationKeys;

  sourceLinkClicked(source: ErrorDetail['source']): void {
    source.element.scrollIntoView();
    source.element.focus();
    this.errorSourceLinkClicked.emit()
  }
}
